import { useDesktop } from "../hooks";
import { motion } from "framer-motion";
import { SignupComp } from "../components";

const Signup = () => {
  return (
    <motion.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0.4 }}
      transition={{ duration: 0.5 }}
      className="signup"
    >
      {useDesktop() >= 1024 && (
        <section className="signup-showcase-content">
          <h1>
            It's good to have <br /> you here!
          </h1>
          <p>Create account to get started...</p>
        </section>
      )}
      <SignupComp />
    </motion.main>
  );
};

export default Signup;
